import {TextField} from "@material-ui/core";
import {Button, Form} from "react-bootstrap";
import {useState} from "react";
import Message from "../message";

function Gst() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

    const [gst_col_name, setGst_col_name] = useState("");
    const [gst, setGst] = useState("");
    const [status_gst, setStatus_gst] = useState("");

    const sumbit_gst = async () => {
        setStatus_gst("");

        if (gst.length <= 0) {
            setStatus_gst("Upload some files!");
        } else if (gst_col_name === "") {
            setStatus_gst("Fill column name!");
        } else {
            const gst_formData = new FormData();
            gst_formData.set("file", gst);

            const requestOptions = {
                method: "POST",
                body: gst_formData,
            };

            try {
                const gst_response = await fetch(
                    apiServer + `api/gst/upload_file?col_name=${gst_col_name}`,
                    requestOptions
                );
                const gst_status_id = await gst_response.json();

                const gst_status = gst_status_id.detail
                    ? gst_status_id.detail
                    : gst_status_id;

                setStatus_gst(gst_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "20px"}}>
            <TextField
                style={{marginBottom: "15px", width: "100%"}}
                value={gst_col_name}
                onChange={(e) => setGst_col_name(e.target.value)}
                id="outlined-basic"
                label="Column name"
                variant="filled"
            />
            <Form.Control type="file" onChange={(e) => setGst(e.target.files[0])}/>
            <Button
                variant="primary"
                style={{marginTop: "20px", width: "100%"}}
                onClick={() => sumbit_gst()}
            >
                Submit
            </Button>
            {Message(status_gst, setStatus_gst)}
        </div>
    );
}

export default Gst;
